export default __webpack_public_path__ + "static/media/attachments.58718ffc.md";